<template>
  <el-dialog
    :visible.sync="upgradePlanVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="upgrade-plan-dialog-border">
      <div class="upgrade-plan-title">Upgrade Your Plan</div>
      <!-- 第一步 -->
      <div v-if="active === 1" class="upgrade-plan-subtitle" >Get access to:</div>
      <div v-if="active === 1" class="upgrade-plan-list">
        <div v-for="(item,index) in upgradePlanList" :key="index" class="upgrade-plan-row">
          <div class="upgrade-plan-left"><img :src="item.upgradePlanImg"/></div>
          <div class="upgrade-plan-right">
            <div class="upgrade-plan-right-title">{{item.upgradePlanTitle}}</div>
            <div class="upgrade-plan-right-content">{{item.upgradePlancontent}}</div>
            <el-divider></el-divider>
          </div>
        </div>
      </div>
      <!-- 第二步 -->
      <div v-if="active === 2" class="upgrade-plan-features">
        <div class="upgrade-plan-features-user">Hey {{userName}}.</div>
        <div class="upgrade-plan-features-tips">For more features please upgrade your plan</div>
        <div class="upgrade-plan-features-tips">What would you like to talk about?</div>
        <el-form :model="upgradePlanForm" ref="upgradePlanForm" :rules="rules" v-loading="loading">
          <el-form-item
            prop="talkAbout"
          >
            <el-select v-model="upgradePlanForm.talkAbout"  placeholder="What would you like to talk about?">
              <el-option
                v-for="item in talkAboutList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="upgrade-plan-action" v-if="active ===1">
        <div class="upgrade-plan-consult" @click="next">Consult with Sales</div>
        <div class="upgrade-plan-close" @click="closeUpgradePlanDialog">Close</div>
      </div>
      <div class="upgrade-plan-action" v-if="active ===2">
        <div v-loading="loading" class="upgrade-plan-consult" @click="confirmUpgradePlan">Done</div>
        <div v-loading="loading" class="upgrade-plan-close" @click="closeUpgradePlanDialog">Maybe Later</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { postAction } from '../../../api/manage'
export default {
  data() {
    return {
      active: 1,
      upgradePlanVisible: false,
      userName: '',
      upgradePlanList: [
        {
          upgradePlanImg: require('@/assets/img/vilocal/more-stores.png'),
          upgradePlanTitle: 'More stores',
          upgradePlancontent: 'Free trial sales service'
        },
        {
          upgradePlanImg: require('@/assets/img/vilocal/historical-data.png'),
          upgradePlanTitle: 'Historical Data',
          upgradePlancontent: 'Data going back to January 2017'
        },
        {
          upgradePlanImg: require('@/assets/img/vilocal/additional-reports.png'),
          upgradePlanTitle: 'Additional Reports',
          upgradePlancontent: 'Deeper analysis with more metrics,insights and views'
        }
      ],
      talkAboutList: [
        {value: "I'd like to upgrade my plan"},
        {value: "I'd like to learn more about the Platform"},
        {value: "I'd like to purchase the full report"}
      ],
      upgradePlanForm: {
        talkAbout: ''
      },
      rules: {
        talkAbout: [
          { required: true, message: 'Please select ', trigger: ['blur', 'change'] }
        ]
      },
      loading: false
    }
  },
  methods: {
    confirmUpgradePlan() {
      if (this.loading) {
        return
      }
      this.$refs['upgradePlanForm'].validate(async (valid) => {
        if (valid) {
          this.loading = true
          let isSuccess = this.pushUpgradePlan(this.upgradePlanForm.talkAbout)
          if (isSuccess) {
            this.$message.success('Submission successful.')
            this.loading = false
            this.closeUpgradePlanDialog()
          }
          this.loading = false
        }
      })
    },
    /**
     * 公共方法请求后端
     */
    async pushUpgradePlan(isTalkAbout) {
      const params = {}
      params.step = 'consult-sales'
      if (isTalkAbout) {
        params.step = 'upgrade-plan'
        params.talkAbout = isTalkAbout
      }
      let response = await postAction('/brand/vilocal/api/v0.2/upgrade-plan', params)
      if (response.success) {
        return response.success
      }
      this.$message.warning(response.message)
    },
    init() {
      const userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      if (userInfo) {
        this.userName = userInfo.firstName + '  ' + userInfo.lastName
      }
      this.active = 1
      this.upgradePlanVisible = true
      this.upgradePlanForm.talkAbout = ''
      this.pushUpgradePlan()
    },
    closeUpgradePlanDialog() {
      this.upgradePlanVisible = false
    },
    next() {
      this.active = 2
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog{
  width: 538px;
  border: 1px solid #E1E1E1;
}
.upgrade-plan-dialog-border{
  width: 85%;
  margin:0 auto;
  text-align: center;
  .upgrade-plan-title{
    margin-top: 30px;
    font-size: 18px;
    font-family:Satoshi-Bold !important;
    color: #262B2F;
  }
  .upgrade-plan-subtitle{
    color: #262B2F;
    margin-top: 10px;
  }
}
.upgrade-plan-row{
  display: flex;
  align-items: center;
  margin: 20px 0px;
  .upgrade-plan-left{
    width: 62px;
    height: 62px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .upgrade-plan-right{
    text-align: left;
    margin-left: 30px;
    width: 350px;
    .upgrade-plan-right-title{
      font-size: 16px;
      font-family: Satoshi-Bold !important;
      color: #262B2F;
    }
    .upgrade-plan-right-content{
      color: #262B2F;
    }
  }
}
.upgrade-plan-action{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 30px 0px;
  .upgrade-plan-consult,.upgrade-plan-close{
    height: 40px;
    border-radius:5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .upgrade-plan-consult{
    width: 230px;
    background: #262B2F;
    color: #FFFFFF;
  }
  .upgrade-plan-close{
    width: 130px;
    background: #FFFFFF;
    color: #262B2F;
    border: 1px solid #262B2F;
    margin-left: 10px;
  }
}
.upgrade-plan-features{
  margin-top: 30px;
  .upgrade-plan-features-user,.upgrade-plan-features-tips{
    line-height: 25px;
    color: #262B2F;
  }
}
/deep/ .el-select{
  width: 100%;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/ai-recommendations/ai-recommendations-upgrade-plan.vue